

export const CashRadio = () => {

    return (
        <div className="form-check">
            <input className="form-check-input" type="radio" name="pay-methods" value='cash' id="cash" defaultChecked/>
            <label className="form-check-label fs-6 fw-bold" htmlFor="cash">
                Готівка - при отриманні замовлення
            </label>
        </div>
    )
}